import React from 'react';

const MensajeError = (props) => {
  return (
    props.mError ? <p> { props.mError } </p> : null 
  )
}

export default MensajeError



// WEBPACK FOOTER //
// ./src/layout/MensajeError.js